import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { _chains } from '@rainbow-me/rainbowkit/dist/config/getDefaultConfig';

export const mevmChainConfig = {
	id: 41000, // Replace with the correct chain ID for Movement-Mainnet
	name: 'Movement-Mainnet',
	nativeCurrency: {
		name: 'Move',
		symbol: 'MOVE',
		decimals: 18,
	},
	rpcUrls: {
		default: {
			http: ['https://mevm.movement-porto.io/'], // Replace with the correct RPC endpoint
		},
	},
	blockExplorers: {
		default: {
			name: 'Movement-Mainnet Explorer',
			url: 'https://explorer.movement-porto.io', // Replace with the actual explorer URL
		},
	},
};

const testNet: _chains = [mevmChainConfig];

export const wagmiConfig = getDefaultConfig({
	appName: 'RNDM',
	projectId: 'YOUR_PROJECT_ID',
	chains: testNet,
	ssr: false,
});
